export enum EOrganisationCategory {
  civilian = '4265ba31-52ba-40a8-8e5b-84b6776765d2',
  state = '166ba358-ea9a-43b1-8df7-926e9ce72096',
  military = 'b9de92ba-1096-4848-9978-72a872b1d81d',
  police = '77d6d39a-47ed-4d42-9ec0-e0d350cdcc40',
}
